import PasswordRecover from "./PasswordRecover";
export default PasswordRecover;
